import o from "react";
import { S as t } from "./ShimmerBlock-hNiBn9_0.es.js";
import './Loading.css';const d = "Loading-module__loading___zRzt9", a = "Loading-module__titleFirstRow___BMgb-", i = "Loading-module__titleSecondRow___xkH1o", l = "Loading-module__bodyFirstRow___qsaTO", n = "Loading-module__bodySecondRow___AY3lr", e = {
  loading: d,
  titleFirstRow: a,
  titleSecondRow: i,
  bodyFirstRow: l,
  bodySecondRow: n
}, s = () => /* @__PURE__ */ o.createElement("div", { className: e.loading, "data-testid": "card-loading" }, /* @__PURE__ */ o.createElement(t, { className: e.titleFirstRow }), /* @__PURE__ */ o.createElement(t, { className: e.titleSecondRow }), /* @__PURE__ */ o.createElement(t, { className: e.bodyFirstRow }), /* @__PURE__ */ o.createElement(t, { className: e.bodySecondRow }));
s.displayName = "Loading";
export {
  s as L
};
